export enum EnumApiAudit {
  /** 举报违规内容 */
  reportViolation = '/audit/api/report/violation'
}
